import {
  ON_START_GET_MAIL,
  ON_ERROR_GET_MAIL,
  ON_GET_MAIL,ON_GET_GMAIL,
  ON_START_GET_MAIL_LIST,
  ON_ERROR_GET_MAIL_LIST,
  ON_GET_MAIL_LIST,ON_GET_GMAIL_LIST,
  ON_START_GET_MAIL_FOLDERS,
  ON_ERROR_GET_MAIL_FOLDERS,
  ON_GET_MAIL_FOLDERS,ON_GET_GMAIL_FOLDERS,
  ON_START_DELETE_MAILS,ON_DELETE_DRAFT_GMAILS,
  ON_ERROR_DELETE_MAILS,
  ON_DELETE_MAILS,
  ON_START_MOVE_MAILS,
  ON_ERROR_MOVE_MAILS,
  ON_MOVE_MAILS,
  ON_START_SEND_MAIL_AS_NEW,
  ON_ERROR_SEND_MAIL_AS_NEW,
  ON_SEND_MAIL_AS_NEW,ON_SEND_GMAIL_AS_NEW,
  ON_START_ATTACH_MAIL_TO_KUND,
  ON_ERROR_ATTACH_MAIL_TO_KUND,
  ON_ATTACH_MAIL_TO_KUND,ON_ATTACH_GMAIL_TO_KUND,
  ON_START_CREATE_REPLY_MAIL,
  ON_ERROR_CREATE_REPLY_MAIL,
  ON_CREATE_REPLY_MAIL,ON_CREATE_REPLY_GMAIL,
  ON_START_CREATE_FORWARD_MAIL,
  ON_ERROR_CREATE_FORWARD_MAIL,
  ON_CREATE_FORWARD_MAIL,ON_CREATE_FORWARD_GMAIL,
  ON_CREATE_SIGNATURE_MAIL,
  ON_ERROR_CREATE_SIGNATURE_MAIL,
  ON_START_CREATE_SIGNATURE_MAIL,
  ON_UPDATE_SIGNATURE_MAIL,
  ON_ERROR_UPDATE_SIGNATURE_MAIL,
  ON_START_UPDATE_SIGNATURE_MAIL,
  ON_DELETE_SIGNATURE_MAIL,
  ON_ERROR_DELETE_SIGNATURE_MAIL,
  ON_START_DELETE_SIGNATURE_MAIL,
  ON_GET_SIGNATURE_MAIL,
  ON_ERROR_GET_SIGNATURE_MAIL,
  ON_START_GET_SIGNATURE_MAIL,
  ON_SET_DEFAULT_SIGNATURE_MAIL,
  ON_START_SET_DEFAULT_SIGNATURE_MAIL,
  ON_ERROR_SET_DEFAULT_SIGNATURE_MAIL,
  ON_FETCH_URVAL_MAIL,
  ON_ERROR_FETCH_URVAL_MAIL,
  ON_START_FETCH_URVAL_MAIL,
} from "../constants/ActionTypes";
import {isUndefined} from 'lodash'
import { translate } from "../util/intlHelper";

const INIT_STATE = {
  responseMail: null,
  loadingMail: false,
  currentMailList: [],

  responseFolders: null,
  loadingFolders: false,
  currentMailFolders: [],

  nextMail: true,
  nextUrl: null,
  currentMail: null,
  signatures: [],

  currentMailUrval: [],
  loadingUrval: false
}

//responseMail
// responseMail sev: 1: success, 2 waring: 3: Error

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    // case SET_ZERO_EVENT:{
    //   return INIT_STATE;
    // }
    case ON_START_GET_MAIL: {
      console.log("ON_START_GET_MAIL", action)
      return {
        ...state,
        responseMail: null,
        loadingFolders:true,
        loadingMail: true,
        currentMail: null,
      }
    }
    case ON_ERROR_GET_MAIL: {
      console.log("ON_ERROR_GET_MAIL", action)
      return {
        ...state,
        responseMail: {sev: 3, message: translate("Error.Mail.Get"), show: true},
        loadingMail: false,
        loadingFolders:false,
        currentMail: null,
      }
    }
    case ON_GET_MAIL: {
      console.log("ON_GET_MAIL", action)
      return {
        ...state,
        responseMail: {sev: 1, message: action.payload.message, show: false},
        loadingMail: false,
        loadingFolders:false,
        currentMail: action.payload.email,
        currentMailFolders: action.payload.Folder.value,
      }
    }
    case ON_GET_GMAIL: {
      console.log("ON_GET_GMAIL", action)
      return {
        ...state,
        responseMail: {sev: 1, message: action.payload.message, show: false},
        loadingMail: false,
        loadingFolders:false,
        currentMail: action.payload.email,
        currentMailFolders: action.payload.Folder,
      }
    }
    case ON_START_CREATE_FORWARD_MAIL: {
      console.log("ON_START_CREATE_FORWARD_MAIL", action)
      return {
        ...state,
        responseMail: null,
        loadingMail: true,
        currentMail: null,
      }
    }
    case ON_ERROR_CREATE_FORWARD_MAIL: {
      console.log("ON_ERROR_CREATE_FORWARD_MAIL", action)
      return {
        ...state,
        responseMail: {sev: 3, message: translate("Error.Mail.ForwordEmail.create"), show: true},
        loadingMail: false,
        currentMail: null,
      }
    }
    case ON_CREATE_FORWARD_MAIL: {
      console.log("ON_CREATE_FORWARD_MAIL", action)
      return {
        ...state,
        responseMail: {sev: 3, message: action.payload.message, show: false},
        loadingMail: false,
        currentMail: action.payload.email,
      }
    }
    case ON_CREATE_FORWARD_GMAIL: {
      console.log("ON_CREATE_FORWARD_MAIL", action)
      return {
        ...state,
        responseMail: {sev: 3, message: action.payload.message, show: false},
        loadingMail: false,
        currentMail: action.payload.email,
      }
    }
    case ON_START_CREATE_REPLY_MAIL: {
      console.log("ON_START_CREATE_REPLY_MAIL", action)
      return {
        ...state,
        responseMail: null,
        loadingMail: true,
        currentMail: null,
      }
    }
    case ON_ERROR_CREATE_REPLY_MAIL: {
      console.log("ON_ERROR_CREATE_REPLY_MAIL", action)
      return {
        ...state,
        responseMail: {sev: 3, message: translate("Error.Mail.ReplyEmail.create"), show: true},
        loadingMail: false,
        currentMail: null,
      }
    }

    case ON_CREATE_REPLY_GMAIL: {
      console.log("ON_CREATE_REPLY_GMAIL", action)
      return {
        ...state,
        responseMail: {sev: 3, message: action.payload.message, show: false},
        loadingMail: false,
        currentMail: action.payload.email,
      }
    }
    case ON_CREATE_REPLY_MAIL: {
      console.log("ON_CREATE_REPLY_MAIL", action)
      return {
        ...state,
        responseMail: {sev: 3, message: action.payload.message, show: false},
        loadingMail: false,
        currentMail: action.payload.email,
      }
    }
    case ON_START_GET_MAIL_LIST: {
      console.log("ON_START_GET_MAIL_LIST", action)
      return {
        ...state,
        responseMail: null,
        loadingMail: true,
        currentMailList: parseInt(action.payload.Buffer) === 1 ? state.currentMailList : [],
        nextMail: true,
        nextUrl: null
      }
    }
    case ON_ERROR_GET_MAIL_LIST: {
      console.log("ON_ERROR_GET_MAIL_LIST", action)
      return {
        ...state,
        responseMail: {sev: 3, message: translate("Error.Mail.Emaillist.get"), show: true},
        loadingMail: false,
        currentMailList: [],
        nextUrl: null
      }
    }
    case ON_GET_GMAIL_LIST: {
      console.log("ON_GET_GMAIL_LIST", action)
      return {
        ...state,
        currentMail: null,
        responseMail: {sev: 1, message: action.payload.message, show: false},
        loadingMail: false,
        currentMailList: parseInt(action.payload.Buffer) === 1 ? state.currentMailList.concat(action.payload.Emails.messages) : action.payload.Emails.messages,
        nextMail: !isUndefined(action.payload.Emails.nextPageToken),
        nextUrl: !isUndefined(action.payload.Emails.nextPageToken) ? action.payload.Emails.nextPageToken : null,
        currentMailFolders: action.payload.Folder,
      }
    }
    case ON_GET_MAIL_LIST: {
      console.log("ON_GET_MAIL_LIST", action)
      return {
        ...state,
        currentMail: null,
        responseMail: {sev: 1, message: action.payload.message, show: false},
        loadingMail: false,
        currentMailList: parseInt(action.payload.Buffer) === 1 ? state.currentMailList.concat(action.payload.Emails.value) : action.payload.Emails.value,
        nextMail: !isUndefined(action.payload.Emails['@odata.nextLink']),
        nextUrl: !isUndefined(action.payload.Emails['@odata.nextLink']) ? action.payload.Emails['@odata.nextLink'] : null,
        currentMailFolders: action.payload.Folder.value,
      }
    }
    case ON_START_GET_MAIL_FOLDERS: {
      console.log("ON_START_GET_MAIL_FOLDERS", action)
      return {
        ...state,
        responseFolders: null,
        loadingFolders: true,
        currentMailFolders: [],
      }
    }
    case ON_ERROR_GET_MAIL_FOLDERS: {
      console.log("ON_ERROR_GET_MAIL_FOLDERS", action)
      return {
        ...state,
        responseFolders: {sev: 3, message: translate("Error.Mail.Folders.get"), show: true},
        loadingFolders: false,
        currentMailFolders: [],
      }
    }
    case ON_GET_MAIL_FOLDERS: {
      console.log("ON_GET_MAIL_FOLDERS", action)
      return {
        ...state,
        responseFolders: {sev: 1, message: action.payload.message, show: false},
        loadingFolders: false,
        currentMailFolders: action.payload.Folder.value,
      }
    }
    case ON_GET_GMAIL_FOLDERS: {
      console.log("ON_GET_MAIL_FOLDERS", action)
      return {
        ...state,
        responseFolders: {sev: 1, message: action.payload.message, show: false},
        loadingFolders: false,
        currentMailFolders: action.payload.Folder,
      }
    }
    case ON_START_SEND_MAIL_AS_NEW: {
      console.log("ON_START_SEND_MAIL_AS_NEW", action.payload)
      return {
        ...state,
        responseMail: null,
      }
    }
    case ON_ERROR_SEND_MAIL_AS_NEW: {
      console.log("ON_ERROR_SEND_MAIL_AS_NEW", action.payload)
      return {
        ...state,
        responseMail: {sev: 3, message: translate("Error.Mail.send"), show: true},
      }
    }
    case ON_SEND_MAIL_AS_NEW: {
      console.log("ON_SEND_MAIL_AS_NEW", action.payload)
      return {
        ...state,
        responseMail: {sev: 1, message: action.payload.message, show: true},
      }
    }
    case ON_SEND_GMAIL_AS_NEW: {
      console.log("ON_SEND_GMAIL_AS_NEW", action.payload)
      return {
        ...state,
        responseMail: {sev: 1, message: action.payload.message, show: true},
      }
    }
    case ON_START_ATTACH_MAIL_TO_KUND: {
      console.log("ON_START_ATTACH_MAIL_TO_KUND", action.payload)
      return {
        ...state,
        responseMail: null,
      }
    }
    case ON_ERROR_ATTACH_MAIL_TO_KUND: {
      console.log("ON_ERROR_ATTACH_MAIL_TO_KUND", action.payload)
      return {
        ...state,
        responseMail: {sev: 3, message: translate("Error.Mail.Attach.Customer"), show: true},
      }
    }
    case ON_ATTACH_MAIL_TO_KUND: {
      console.log("ON_ATTACH_MAIL_TO_KUND", action.payload)
      return {
        ...state,
        responseMail: {sev: 1, message: translate("Action.Main.Pinned.Customer"), show: true},
      }
    }
    case ON_ATTACH_GMAIL_TO_KUND: {
      console.log("ON_ATTACH_GMAIL_TO_KUND", action.payload)
      return {
        ...state,
        responseMail: {sev: 1, message: translate("Action.Main.Pinned.Customer"), show: true},
      }
    }
    case ON_START_DELETE_MAILS: {
      console.log("ON_START_DELETE_MAILS", action.payload)
      return {
        ...state,
        responseMail: null,
      }
    }
    case ON_ERROR_DELETE_MAILS: {
      console.log("ON_ERROR_DELETE_MAILS", action.payload)
      return {
        ...state,
        responseMail: {sev: 3, message: translate("Error.Mail.Delete"), show: true},
      }
    }
    case ON_DELETE_MAILS: {
      console.log("ON_DELETE_MAILS", action.payload)
      return {
        ...state,
        responseMail: {sev: 2, message: action.payload.message, show: true},
      }
    }
    case ON_DELETE_DRAFT_GMAILS: {
      console.log("ON_DELETE_DRAFT_GMAILS", action.payload)
      return {
        ...state,
        responseMail: {sev: 2, message: action.payload.message, show: true},
      }
    }
    case ON_START_MOVE_MAILS: {
      console.log("ON_START_MOVE_MAILS", action.payload)
      return {
        ...state,
        responseMail: null,
      }
    }
    case ON_ERROR_MOVE_MAILS: {
      console.log("ON_ERROR_MOVE_MAILS", action.payload)
      return {
        ...state,
        responseMail: {sev: 3, message: translate("Error.Mail.Move"), show: true},
      }
    }
    case ON_MOVE_MAILS: {
      console.log("ON_MOVE_MAILS", action.payload)
      return {
        ...state,
        responseMail: {sev: 1, message: action.payload.message, show: true},
      }
    }

    case ON_CREATE_SIGNATURE_MAIL: {
      console.log("ON_CREATE_SIGNATURE_MAIL", action.payload)
      return {
        ...state,
        signatures: action.payload.Signatures,
      }
    }
    case ON_ERROR_CREATE_SIGNATURE_MAIL: {
      console.log("ON_ERROR_CREATE_SIGNATURE_MAIL", action.payload)
      return {
        ...state,
        signatures: [],
      }
    }
    case ON_START_CREATE_SIGNATURE_MAIL: {
      console.log("ON_START_CREATE_SIGNATURE_MAIL", action.payload)
      return {
        ...state,
        // signatures: [],
      }
    }
    case ON_UPDATE_SIGNATURE_MAIL: {
      console.log("ON_UPDATE_SIGNATURE_MAIL", action.payload)
      return {
        ...state,
        signatures: action.payload.Signatures,
      }
    }
    case ON_ERROR_UPDATE_SIGNATURE_MAIL: {
      console.log("ON_ERROR_UPDATE_SIGNATURE_MAIL", action.payload)
      return {
        ...state,
        signatures: [],
      }
    }
    case ON_START_UPDATE_SIGNATURE_MAIL: {
      console.log("ON_START_UPDATE_SIGNATURE_MAIL", action.payload)
      return {
        ...state,
        // signatures: [],
      }
    }
    case ON_DELETE_SIGNATURE_MAIL: {
      console.log("ON_DELETE_SIGNATURE_MAIL", action.payload)
      return {
        ...state,
        signatures: action.payload.Signatures,
      }
    }
    case ON_ERROR_DELETE_SIGNATURE_MAIL: {
      console.log("ON_ERROR_DELETE_SIGNATURE_MAIL", action.payload)
      return {
        ...state,
        signatures: [],
      }
    }
    case ON_START_DELETE_SIGNATURE_MAIL: {
      console.log("ON_START_DELETE_SIGNATURE_MAIL", action.payload)
      return {
        ...state,
        // signatures: [],
      }
    }
    case ON_SET_DEFAULT_SIGNATURE_MAIL: {
      console.log("ON_SET_DEFAULT_SIGNATURE_MAIL", action.payload)
      return {
        ...state,
        signatures: action.payload.Signatures,
      }
    }
    case ON_ERROR_SET_DEFAULT_SIGNATURE_MAIL: {
      console.log("ON_ERROR_SET_DEFAULT_SIGNATURE_MAIL", action.payload)
      return {
        ...state,
        signatures: [],
      }
    }
    case ON_START_SET_DEFAULT_SIGNATURE_MAIL: {
      console.log("ON_START_SET_DEFAULT_SIGNATURE_MAIL", action.payload)
      return {
        ...state,
        // signatures: [],
      }
    }
    case ON_GET_SIGNATURE_MAIL: {
      console.log("ON_GET_SIGNATURE_MAIL", action.payload)
      return {
        ...state,
        signatures: action.payload.Signatures,
      }
    }
    case ON_ERROR_GET_SIGNATURE_MAIL: {
      console.log("ON_ERROR_GET_SIGNATURE_MAIL", action.payload)
      return {
        ...state,
        signatures: [],
      }
    }
    case ON_START_GET_SIGNATURE_MAIL: {
      console.log("ON_START_GET_SIGNATURE_MAIL", action.payload)
      return {
        ...state,
        signatures: [],
      }
    }
    case ON_FETCH_URVAL_MAIL: {
      console.log("ON_FETCH_URVAL_MAIL", action.payload)
      return {
        ...state,
        currentMailUrval: action.payload.currentMailUrval,
        loadingUrval: false
      }
    }
    case ON_ERROR_FETCH_URVAL_MAIL: {
      console.log("ON_ERROR_FETCH_URVAL_MAIL", action.payload)
      return {
        ...state,
        currentMailUrval: [],
        loadingUrval: false
      }
    }
    case ON_START_FETCH_URVAL_MAIL: {
      console.log("ON_START_FETCH_URVAL_MAIL", action.payload)
      return {
        ...state,
        currentMailUrval: [],
        loadingUrval: true
      }
    }
    
    default: {
      return state;
    }
  }
}
